import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";


@Entity('states')
export class StatesEntity {

    @PrimaryGeneratedColumn('increment', { name: 'state_id' })
    stateId: number;
  

  @Column("char",{
      nullable:false,
      length:50,
      name:"state_name"
      })
  stateName:string;




}
